import { memo } from 'react';
import { FIFTHS_ORDER, PITCH_CLASS_NAMES, type Scale } from '@tonist/shared';
import { petalCount, zoneCentre, zoneKey, type MandalaLayout, type RingIndex } from '../../mandala/geometry';
import { zoneAriaLabel } from '../../music/tuning';

/** Invisible DOM buttons over every zone so keyboard and screen-reader users can sound the mandala. */
export const ZoneButtons = memo(function ZoneButtons({ layout, scale, tonicPc, onZone, onTonic }: {
  layout: MandalaLayout; scale: Scale; tonicPc: number;
  onZone: (ring: RingIndex, index: number) => void; onTonic: (pc: number) => void;
}) {
  const degrees = scale.semitones.length;
  const petals = petalCount(degrees);
  const items: Array<{ key: string; x: number; y: number; label: string; onClick: () => void }> = [];
  const c0 = zoneCentre(layout, degrees, 0, 0);
  items.push({ key: zoneKey(0, 0), x: c0.x, y: c0.y, label: `Bindu: ${zoneAriaLabel(scale, tonicPc, 0, -1)}`, onClick: () => onZone(0, 0) });
  for (const ring of [1, 2, 3] as const) {
    for (let i = 0; i < petals; i++) {
      const c = zoneCentre(layout, degrees, ring, i);
      items.push({ key: zoneKey(ring, i), x: c.x, y: c.y, label: zoneAriaLabel(scale, tonicPc, i, ring - 1), onClick: () => onZone(ring, i) });
    }
  }
  for (let i = 0; i < 12; i++) {
    const c = zoneCentre(layout, degrees, 4, i);
    const pc = FIFTHS_ORDER[i]!;
    items.push({ key: zoneKey(4, i), x: c.x, y: c.y, label: `Set tonic ${PITCH_CLASS_NAMES[pc]}`, onClick: () => onTonic(pc) });
  }
  return (
    <div className="zone-buttons" role="group" aria-label="Mandala zones">
      {items.map((it) => (
        <button key={it.key} type="button" className="zone-btn" style={{ left: it.x, top: it.y }} aria-label={it.label} onClick={it.onClick}>{it.label}</button>
      ))}
    </div>
  );
});
